import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

//router
import { createBrowserRouter, RouterProvider } from "react-router-dom";
//store
import { Provider } from "react-redux";
//reducer
import { store } from "./store";

import Index from "./views/index";
import { IndexRouters } from "./router";
import { LandingModulesRouter } from './router/landing-modules-router'
import { SimpleRouter } from "./router/simple-router";
import { DefaultRouter } from "./router/default-router";
import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from "moment-timezone";

moment.tz.setDefault("Asia/Kolkata");

const router = createBrowserRouter([
  {
    path: "/",
    element: <Index />,
  },
  ...DefaultRouter,
  ...IndexRouters,
  ...SimpleRouter,
  ...LandingModulesRouter
], { basename: process.env.PUBLIC_URL });

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.Fragment>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
          <App>
            <ToastContainer />
            <RouterProvider router={router}></RouterProvider>
          </App>
      </QueryClientProvider>
    </Provider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
